module.exports = __webpack_public_path__ + "img/bandera-espanha.4187b11b.png";